module.exports = __webpack_public_path__ + "img/dsc.37b4fba9.jpg";